import { Pipe, PipeTransform } from '@angular/core';
import { EnvironmentCheckService } from '@fleet-beat/core';
import { WrapPanelVisibility } from '@fleet-beat/wrap-panel';
import { EditorFieldType } from '../enums';
import { EditorColumnConfig } from '../models/editor-column-config.model';
import { EditorItemConfig } from '../models/editor-item-type';

@Pipe({
  name: 'editorItemVisibility',
})
export class EditorItemVisibilityPipe implements PipeTransform {
  constructor(private environmentCheckService: EnvironmentCheckService) {}

  transform(config: EditorItemConfig | EditorColumnConfig): WrapPanelVisibility {
    if (!config) {
      return WrapPanelVisibility.None;
    }
    if (config.type === EditorFieldType.HIDDEN) {
      return WrapPanelVisibility.Hide;
    }
    if (!this.environmentCheckService.check(config.environments)) {
      return WrapPanelVisibility.None;
    }

    return config.visibility || WrapPanelVisibility.Visible;
  }
}
